import { collection, getDocs } from 'firebase/firestore';
import { useState } from 'react';

import firebase from '../firebase';
import { useAppSelector } from '../store/hooks';
import { IBillBeneficiary } from '../types/beneficiary';

const { REACT_APP_FIREBASE_FIRESTORE_BENEFICIARY_LIST_PATH } = process.env;

const useFetchBillBeneficiaries = () => {
  const [status, setStatus] = useState<
    'idle' | 'loading' | 'success' | 'failed'
  >('idle');

  const { value: authValue } = useAppSelector((state) => state.auth);

  const userId = authValue?.data?.user?.id;

  let beneficiaries: IBillBeneficiary[] | [] = [];

  const getBeneficiaries = async () => {
    try {
      setStatus('loading');

      const beneficiariesCol = collection(
        firebase,
        `/${REACT_APP_FIREBASE_FIRESTORE_BENEFICIARY_LIST_PATH}/business_${userId}/${userId}/savedBills`
      );

      const beneficiariesSnapshot = await getDocs(beneficiariesCol);
      const beneficiariesList = beneficiariesSnapshot.docs.map(
        (beneficiary) => ({
          ...beneficiary.data(),
          id: beneficiary.id,
        })
      );

      beneficiaries = beneficiariesList;

      setStatus('success');

      return beneficiaries;
    } catch (error) {
      setStatus('failed');

      return [];
    }
  };

  return { status, getBeneficiaries };
};

export default useFetchBillBeneficiaries;
